<template>
  <content-filter
    v-on:searchClick="searchClick"
    :createNewItem="createNewItem"
    :filterGroups="filterGroups"
    v-on:filtrate="filtrate"
    :infoMsg="infoMsg"
  >
    <template slot="customBtns">
      <button class="button" v-on:click="saveClick">Save</button>

      <b-field style="display: inline-flex; margin-left:24px;">
        <b-tooltip label="Expand all cards">
          <b-radio-button v-model="expanded" native-value="expanded" type="is-success">
            <b-icon icon="mdi mdi-menu-down mdi-24px"></b-icon>
            <span
              class="is-hidden-widescreen-only is-hidden-desktop-only is-hidden-tablet-only is-hidden-mobile"
            >Expand all cards</span>
          </b-radio-button>
        </b-tooltip>
        <b-tooltip label="Collapse all cards">
          <b-radio-button v-model="expanded" native-value="collapsed">
            <b-icon icon="mdi mdi-menu-up mdi-24px"></b-icon>
            <span
              class="is-hidden-widescreen-only is-hidden-desktop-only is-hidden-tablet-only is-hidden-mobile"
            >Collapse all cards</span>
          </b-radio-button>
        </b-tooltip>
      </b-field>
    </template>
  </content-filter>
</template>

<script>
import ContentFilter from "./ContentFilter";

export default {
  name: "changes-content-filter",
  components: { ContentFilter },
  props: {
    createNewItem: Function,
    saveClick: Function,
    filterGroups: Array, //one item -> name
    infoMsg: String //HTML, e.g. count of the items
  },
  data() {
    return {
      curFilter: "",
      expanded: "collapsed"
    };
  },
  methods: {
    //return filtration type to the parent
    filtrate(groupName) {
      this.curFilter = groupName;
      this.$emit("filtrate", groupName);
    },
    searchClick(searchingText) {
      this.$emit("searchClick", searchingText);
    }
  },
  watch: {
    expanded: function(newExpanded) {
      let isExpended = newExpanded == "expanded" ? true : false;
      this.$emit("expand", isExpended);
    }
  },
  created() {
    if (
      this.filterGroups !== null &&
      this.filterGroups != undefined &&
      this.filterGroups.length > 0
    )
      this.curFilter = this.filterGroups[0];
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ChangesContentFilter.Vue